
document.addEventListener('DOMContentLoaded', function (){
    initMediaCarousel();
});

function initMediaCarousel(prefixClass){
    prefixClass = prefixClass ? prefixClass+' ' : '';
    const OPTIONS = {}
    const OPTIONS_THUMBS = {
        containScroll: 'trimSnaps',
        dragFree: true
    }
    const viewportNodeMainCarousel = document.querySelector(prefixClass+'.prod-carousel-viewport')
    const viewportNodeThumbCarousel = document.querySelector(
        prefixClass+'.prod-thumbs-viewport'
    )
    const emblaApiMain = EmblaCarousel(viewportNodeMainCarousel, OPTIONS)
    const emblaApiThumb = EmblaCarousel(viewportNodeThumbCarousel, OPTIONS_THUMBS)

    const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
        emblaApiMain,
        emblaApiThumb
    )
    const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
        emblaApiMain,
        emblaApiThumb
    );
    showVariantImage(emblaApiMain, emblaApiThumb);
    document.querySelectorAll('.prod-carousel-btn-ctrl').forEach(function (btn){
        btn.addEventListener('click', function (){
            const isMain = btn.closest('.prod-carousel-main');
            const isLeft = btn.classList.contains('prod-carousel-btn-ctrl-left');
            if(isLeft){
                if(isMain && emblaApiMain.canScrollPrev()) emblaApiMain.scrollPrev();
                if(!isMain && emblaApiThumb.canScrollPrev()) emblaApiThumb.scrollPrev();
            }
            else{
                if(isMain && emblaApiMain.canScrollNext()) emblaApiMain.scrollNext();
                if(!isMain && emblaApiThumb.canScrollNext()) emblaApiThumb.scrollNext();
            }

        });
    });

    emblaApiMain
        .on('destroy', removeThumbBtnsClickHandlers)
        .on('destroy', removeToggleThumbBtnsActive)

    emblaApiThumb
        .on('destroy', removeThumbBtnsClickHandlers)
        .on('destroy', removeToggleThumbBtnsActive)

    const prodInfoBox = document.querySelector('.product__info-wrapper');
    const variantSelector = document.querySelector('variant-selects');
    if(variantSelector && prodInfoBox){
        let variantChanged = false;
        prodInfoBox.addEventListener('change', function (){
            if(!variantChanged) {
                variantChanged = true;
                setTimeout(function () {
                    variantChanged = false;
                }, 1000);
                showVariantImage(emblaApiMain, emblaApiThumb);
            }
        });
    }
}

function addThumbBtnsClickHandlers(emblaApiMain, emblaApiThumb){
    const slidesThumbs = emblaApiThumb.slideNodes()

    const scrollToIndex = slidesThumbs.map(
        (_, index) => () => emblaApiMain.scrollTo(index)
    )

    slidesThumbs.forEach((slideNode, index) => {
        slideNode.addEventListener('click', scrollToIndex[index], false)
    })

    return () => {
        slidesThumbs.forEach((slideNode, index) => {
            slideNode.removeEventListener('click', scrollToIndex[index], false)
        })
    }
}

function addToggleThumbBtnsActive(emblaApiMain, emblaApiThumb){
    const slidesThumbs = emblaApiThumb.slideNodes()

    const toggleThumbBtnsState = () => {
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap())
        const previous = emblaApiMain.previousScrollSnap()
        const selected = emblaApiMain.selectedScrollSnap()
        slidesThumbs[previous].classList.remove('prod-carousel-thumbs-selected')
        slidesThumbs[selected].classList.add('prod-carousel-thumbs-selected')
    }

    const activeThumbItemOnScroll = ()=>{
        const visibleSlides = emblaApiThumb.slidesInView();
        const selected = emblaApiMain.selectedScrollSnap();
        let validSlides = [...visibleSlides];
        let pos = 0;
        if (visibleSlides.length > 6){
            validSlides.pop();
            validSlides.shift();
        }
        else if (visibleSlides[0] == 0){
            validSlides.pop();
        }
        else{
            validSlides.shift();
        }
        if (!validSlides.includes(selected)){
            emblaApiMain.scrollTo(!pos ? validSlides[0] : validSlides[validSlides.length - 1]);
        }
    }

    emblaApiMain.on('select', toggleThumbBtnsState)
    emblaApiThumb.on('init', toggleThumbBtnsState)
    emblaApiThumb.on('scroll', activeThumbItemOnScroll)

    return () => {
        const selected = emblaApiMain.selectedScrollSnap()
        slidesThumbs[selected].classList.remove('prod-carousel-thumbs-selected')
    }
}

function showVariantImage(emblaApiMain, emblaApiThumb){
    let selectedOptions = [];
    let selectedNames = [];
    document.querySelectorAll('variant-selects input[type="radio"]:checked').forEach(function (el){
        if(!selectedNames.includes(el.name)) {
            selectedOptions.push(el.value);
            selectedNames.push(el.name);
        }
    });

    const matchedVariant = PROD_VARIANTS_DATA.find(variant => {
        return variant.options.every((opt, index) => opt === selectedOptions[index]);
    });
    if(matchedVariant){
        const mediaId = matchedVariant.featured_media?.id;

        if(mediaId){
            let mediaIndex = -1;
            document.querySelectorAll('.prod-carousel-container li').forEach(function (_item, index){
                const _mediaId = _item.getAttribute('data-media-id');
                if(_mediaId && _mediaId == mediaId){
                    mediaIndex = index;
                }
            });
            if (mediaIndex > -1){
                emblaApiMain.scrollTo(mediaIndex);
            }
        }
    }
}